<template>
    <div class="hiddenRealms210">
        <div class="row mx-0 mb-0 p-0 gx-0">
            <div class="col-12 p-0">
                <img src="../../../static/img/210.jpeg" alt="Flyer of the exposition" style="width: 100%;">
            </div>
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: black; color: white; display: flex; justify-content: center;">
            <div style="font-size: 16px;" class="py-2 col-12">
                ברוכים.ות הבאים.ות לתערוכה
            </div>
            <div style="font-size: 32px; font-weight: 600;" class="py-2 col-12">
אדם הוא תבנית           </div>
            <div style="font-size: 19px; font-weight: 600;" class="py-2 col-12">
                מינוס 210<br>עומק מקומי
            </div>

        </div>
        <div class="row p-0 m-0 p-3">
            <div v-for="(artwork, index) in artworks" :key="index" @click="toggleAudio(index)"
                class="col-12 mb-2">
                <div class="audioButtonWide d-flex align-items-center"
                    :style="{ backgroundColor: isActive(index) ? '#f1750a' : '#FFFFFF' }">

                    <div class="flex-grow-1 d-flex align-items-center justify-content-between px-3" style="direction: rtl;">
                        <span class="audioButtonLabel" :style="{ color: isActive(index) ? 'white' : '#333' }">
                            {{ artwork.label }}
                        </span>
                        <svg v-if="!isPlaying(index)" xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" :fill="isActive(index) ? 'white' : '#63C4C3'" class="bi bi-play-circle flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" fill="white" class="bi bi-pause-circle flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: black; color: white; display: flex; justify-content: center;">
                       <div style="font-size: 16px;" class="py-2 col-12">
    לחצו על התמונה המתאימה להסבר קולי
</div>
            <div style="font-size: 32px;font-weight: 600;" class="py-2">
                תודה שביקרתם.
            </div>
            <a :href="moreEventsLink" target="_blank" rel="noopener" style="text-decoration: none;">
                <div class="siteButton mt-4">
                    לעוד אירועים
                </div>
            </a>

            <div class="row d-flex justify-content-center mt-4 pt-3" style="border-top: 1px solid white;">

                <a style="text-decoration: none;">
                    <div class="col-12 linksToWebsite ">
                    2026
                    </div>
                </a>
                <a :href="eifoany" style="text-decoration: none;">
                    <div class="col-12 linksToWebsite" style="font-family: 'segoeui';">
                        developped by Eifoany
                    </div>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
import firebase from "firebase/app";

export default {

    data() {
        return {
            eifoany: "https://eifoany.web.app/",
            moreEventsLink: "https://minus210-app.vercel.app/",
            artworks: [],
            audioElements: [],
            currentlyPlayingIndex: null,
            isAudioPlaying: false,
        };
    },

    async mounted() {
        const snap = await firebase.database().ref("pages/210/artworks").once("value");
        const stored = snap.val();
        if (Array.isArray(stored) && stored.length) {
            this.artworks = stored;
        }
    },

    methods: {
        isActive(index) {
            return this.currentlyPlayingIndex === index;
        },
        isPlaying(index) {
            return this.currentlyPlayingIndex === index && this.isAudioPlaying;
        },
        toggleAudio(index) {
            const audioUrl = this.artworks[index].audio;

            if (this.currentlyPlayingIndex !== null) {
                if (this.currentlyPlayingIndex === index) {
                    if (this.audioElements[index].paused) {
                        this.audioElements[index].play();
                        this.isAudioPlaying = true;
                    } else {
                        this.audioElements[index].pause();
                        this.isAudioPlaying = false;
                    }
                    return;
                }
                if (this.audioElements[this.currentlyPlayingIndex]) {
                    this.audioElements[this.currentlyPlayingIndex].pause();
                    this.audioElements[this.currentlyPlayingIndex].currentTime = 0;
                }
            }
            this.audioElements[index] = new Audio(audioUrl);
            this.audioElements[index].addEventListener("ended", () => {
                this.audioElements[index].currentTime = 0;
                if (this.currentlyPlayingIndex === index) {
                    this.currentlyPlayingIndex = null;
                    this.isAudioPlaying = false;
                }
            });
            this.audioElements[index].play();
            this.isAudioPlaying = true;
            this.currentlyPlayingIndex = index;
        },
    },

};
</script>

<style scoped>
.linksToWebsite {
    color: white !important;
    text-decoration: none !important
}

.siteButton {
    background: #63C4C3;
    width: 300px;
    margin: 0 auto;
    height: 40px;
    font-size: 20px;
    font-family: VarelaRound, sans-serif;
    border-radius: 3px;
    padding-top: 5px;
    color: white !important;
    text-decoration: none !important
}

.audioButtonWide {
    width: 100%;
    border: solid 1px #63C4C3;
    border-radius: 15px;
    height: 80px;
    box-shadow: 0px 0px 20px 3px #80808026;
    overflow: hidden;
    cursor: pointer;
}

.audioButtonLabel {
    font-size: 16px;
    font-weight: 600;
    font-family: VarelaRound, sans-serif;
    text-align: right;
}

.fontHeebo {
    font-family: VarelaRound, sans-serif;
}
</style>
